import { IConfigVecino } from 'modelosSeguridad/src';

/**
 * URL pública de la foto de perfil del vecino (`datosPersonales.urlFoto`,
 * cargada desde la app de botón). Centralizado para que listados y
 * tratamiento de alertas lean el mismo campo.
 */
export function getUrlFotoVecino(
  configVecino?: IConfigVecino,
): string | undefined {
  return configVecino?.datosPersonales?.urlFoto;
}
